<template>
  <b-button
    class="ft-btn ft-btn-primary btn-floating float-right my-style"
    pill
    id="changeOnScroll"
    @scroll="scrollFunction"
  >
    <icon-base
      icon-name="plus"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      style="margin-bottom: -1px"
      id="plusIcon"
    >
      <icon-plus />
    </icon-base>
    <span id="addLoadtext"> Add Load</span>
  </b-button>
</template>

<style>
.my-style {
  width: 153px;
  height: 56px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.75px;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.08), 0px 2px 16px rgba(0, 0, 0, 0.08),
    0px 2px 8px rgba(0, 0, 0, 0.12);
  z-index: 20;
}

.scroll-downFAB {
  width: 56px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  transition: all 0.4s ease-in-out 0.2s;
}

.scroll-downText {
  display: none;
}

.scroll-downIcon {
  margin-right: 0px;
}

.scroll-upFAB {
  width: 153px;
  transition: all 0.4s ease-in-out 0.1s;
}

.scroll-upText {
  display: inline-block;
}

.scroll-upIcon {
  margin-right: 10px;
}
</style>

<script>
import IconBase from "../components/IconBase.vue";
import IconPlus from "../components/icons/IconPlus.vue";
export default {
  components: {
    IconBase,
    IconPlus,
  },
  created() {
    window.addEventListener("scroll", this.scrollFunction);
  },

  beforeDestroy: function () {
    window.removeEventListener("scroll", this.scrollFunction);
  },

  methods: {
    scrollFunction() {
      let addLoadFab = document.getElementById("changeOnScroll");
      let addLoadText = document.getElementById("addLoadtext");
      let plusIcon = document.getElementById("plusIcon");

      if (window.scrollY) {
        addLoadFab.classList.remove("scroll-upFAB");
        addLoadText.classList.remove("scroll-upText");
        plusIcon.classList.remove("scroll-upIcon");

        addLoadFab.classList.add("scroll-downFAB");
        addLoadText.classList.add("scroll-downText");
        plusIcon.classList.add("scroll-downIcon");
      } else {
        addLoadFab.classList.add("scroll-upFAB");
        addLoadText.classList.add("scroll-upText");
        plusIcon.classList.add("scroll-upIcon");
      }
    },
  },
};
</script>
